import { useToken } from "@bn/api";
import { OauthParamsGrantTypeEnum } from "@bn/api/apiv1";
import { useRememberMe } from "./useRememberMe";

export const useLogin = ({
  shouldUpdateQuery = true,
}: { shouldUpdateQuery?: boolean } = {}) => {
  const { getTokenAsync, getTokenQuery } = useToken({
    shouldUpdateQuery,
  });

  const [, setRememberMe] = useRememberMe();

  const loginAsync = async (attrs: {
    username: string;
    password: string;
    rememberMe?: boolean;
    grant_type?: OauthParamsGrantTypeEnum;
    mfa_challenge_code?: number;
    mfa_secret?: string;
  }) => {
    const result = await getTokenAsync({
      ...attrs,
      grant_type: attrs.grant_type ?? "password",
    });

    if (
      (attrs.grant_type === "password" ||
        attrs.grant_type === "two_factor_authentication") &&
      attrs.rememberMe !== undefined &&
      result.access_token
    ) {
      setRememberMe(attrs.rememberMe);
    }
    return result;
  };

  return {
    loginAsync,
    isFetching: getTokenQuery.isPending,
    isSuccess: getTokenQuery.isSuccess,
    tokenError: getTokenQuery.error?.response as Partial<ApiException> & {
      status: number;
    },
  };
};
